import { render, staticRenderFns } from "./news-board.vue?vue&type=template&id=182c930b&"
import script from "./news-board.vue?vue&type=script&lang=js&"
export * from "./news-board.vue?vue&type=script&lang=js&"
import style0 from "./news-board.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports